import { useMemo, useEffect, useRef } from 'react';
import { useAppDispatch } from '../../../hooks/redux';
import { selectScopes } from '../../../selectors';
import { selectGates } from '../../../reducers/Portal';
import { MARKETING_STUDIO_GATE } from '../../../constants/gates';
import { useStartOnboardingTour } from 'nav-onboarding-tours';
import { MARKETING_STUDIO_TOUR_ID } from 'nav-onboarding-tours/tours';
import { useAppSelector } from '../../../hooks';
import useNavItems from '../../../hooks/useNavItems';
import { selectIsTourHovered } from '../../../features/nav-onboarding-tours/selectors/NavOnboardingTourHover.selector';
import { disableSubmenuToggle } from '../../../reducers/navItems';
import { simpleErrorHandler } from '../../../errors/simpleErrorHandler';
import { jsx as _jsx } from "react/jsx-runtime";
const TOUR = {
  tourId: MARKETING_STUDIO_TOUR_ID,
  type: 'centralizedTour'
};
const OnboardingTour = ({
  isMarketingNavMenuOpen
}) => {
  const isTourHovered = useAppSelector(selectIsTourHovered);
  const dispatch = useAppDispatch();
  const {
    startTour,
    stopTour,
    isActive
  } = useStartOnboardingTour(TOUR, {
    startTour: false
  });
  const timeoutRef = useRef(null);

  // Starts and stops the tour on marketing submenu open/close
  useEffect(() => {
    if (isMarketingNavMenuOpen) {
      startTour().catch(simpleErrorHandler('Error starting tour'));
    } else if (isActive) {
      stopTour().catch(simpleErrorHandler('Error stopping tour'));
    }
  }, [isMarketingNavMenuOpen, startTour, stopTour, isActive]);

  // Prevents submenu close if the tour is hovered and this tour is active
  useEffect(() => {
    if (isTourHovered && isActive) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      dispatch(disableSubmenuToggle({
        disable: true
      }));
    } else {
      // adding a tiny delay to allow moving the mouse back over the submenu and keep the submenu open
      timeoutRef.current = setTimeout(() => {
        dispatch(disableSubmenuToggle({
          disable: false
        }));
      }, 1);
    }
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [isTourHovered, dispatch, isActive]);
  return null;
};
export const MaybeMarketingStudioOnboardingTour = () => {
  const {
    openMenus
  } = useNavItems();
  const scopes = useAppSelector(selectScopes);
  const gates = useAppSelector(selectGates);
  const hasCampaignsReadAccess = useMemo(() => scopes.includes('campaigns-access'), [scopes]);
  const isUngatedForMarketingStudio = useMemo(() => gates.includes(MARKETING_STUDIO_GATE), [gates]);
  const isMarketingNavMenuOpen = useMemo(() => (openMenus === null || openMenus === void 0 ? void 0 : openMenus.primary) === 'marketing', [openMenus]);

  // Only render the tour component if the user has campaigns read access,
  // and is ungated for marketing studio
  if (!hasCampaignsReadAccess || !isUngatedForMarketingStudio) {
    return null;
  }
  return /*#__PURE__*/_jsx(OnboardingTour, {
    isMarketingNavMenuOpen: isMarketingNavMenuOpen
  });
};